import { Space, Button, Flex } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import DataTable from "../Common/DataTable";
import dayjs from "dayjs";

export default function TransactionTable(props) {
  const {
    transactions,
    cardRef,
    tableHeightOffset,
    setSelectedTransaction,
    onViewClicked,
  } = props;

  const COLUMNS = [
    {
      title: "No",
      dataIndex: "number",
      key: "number",
      width: 50,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Invoice No",
      dataIndex: "invoice_no",
      key: "invoice_no",
      sorter: (a, b) => a.invoice_no.localeCompare(b.invoice_no),
    },
    {
      title: "Date",
      dataIndex: "transaction_datetime",
      key: "transaction_datetime",
      sorter: (a, b) =>
        dayjs(a.transaction_datetime).isAfter(dayjs(b.transaction_datetime))
          ? 1
          : -1,
    },
    {
      title: "Payment Method",
      dataIndex: "payment_method",
      key: "payment_method",
    },
    {
      title: "Total (RM)",
      dataIndex: "amount",
      key: "amount",
      render: (t, r, i) => "RM " + (r.amount ?? 0).toFixed(2),
    },
    {
      title: "Action",
      key: "x",
      render: (_, record) => (
        <Space size={"small"}>
          <Button
            type="primary"
            onClick={() => {
              setSelectedTransaction(record);
              onViewClicked(record["key"]);
            }}
          >
            <Flex gap={"small"}>
              <EyeOutlined />
              <div>View</div>
            </Flex>
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <DataTable
      table_data={transactions}
      table_column={COLUMNS}
      scroll_x={700}
      layoutRef={cardRef}
      tableWrapperViewportHeight={1}
      tableHeightOffset={tableHeightOffset}
      default_page_size={10}
      show_size_changer={true}
      on_row={(record) => ({
        onMouseEnter: (e) => e.stopPropagation(),
        onMouseLeave: (e) => e.stopPropagation(),
      })}
    />
  );
}
